<template>
    <div class="w-full">
        <div class="w-full surface-0 border-round-xl p-3 mb-3">
            <div class="flex flex-row justify-content-between align-items-center">
                <span class="text-900 font-medium text-lg xl:text-xl">Заказы eSIM</span>
                <span class="text-600 text-sm xl:text-md">Найдено заказов: {{ total || 0 }}</span>
            </div>
        </div>

        <div v-if="loading" class="w-full">
            <Skeleton v-for="i in 6" :key="i" height="4rem" class="mb-2 border-round-xl" />
        </div>

        <div v-else class="w-full">
            <div v-if="products && products.length">
                <div v-for="(p, idx) in products" :key="p.id || idx"
                    class="w-fill flex flex-column surface-0 overflow-hidden border-round-xl p-3 mb-2">
                    <div class="flex flex-row justify-content-between align-items-start gap-3">
                        <div class="flex-1">
                            <div class="flex gap-2 align-items-center mb-2">
                                <span class="text-800 font-semibold text-sm xl:text-base">{{ getTitle(p) }}</span>
                                <span v-if="p.category"
                                    class="text-500 text-xs border-1 surface-border border-round-md px-2 py-1">{{
                                    p.category }}</span>
                            </div>
                            <div class="flex gap-3 text-700 text-xs xl:text-sm">
                                <span v-if="getDataAmount(p)">{{ t('data') }}: {{ getDataAmount(p) }}</span>
                                <span v-if="getValidity(p)">{{ t('validity') }}: {{ getValidity(p) }}</span>
                                <span v-if="getProviderName(p)">{{ t('provider') }}: {{ getProviderName(p) }}</span>
                            </div>
                        </div>
                        <div class="flex flex-column align-items-end gap-2">
                            <div class="inline-block text-800 font-medium text-base xl:text-xl">
                                {{ formatPrice(p) }}
                            </div>
                            <Button class="p-button-sm border-round-xl" :disabled="loading" label="Подробнее"
                                @click="openPopup(p)" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="w-full">
                <span class="block text-800 mb-3">Тарифы не найдены</span>
            </div>

            <!-- Пагинация -->
            <div class="w-full mt-2">
                <Paginator v-if="total && total > limit" v-model:first="skip" :rows="limit" :totalRecords="total"
                    :rowsPerPageOptions="[10, 20, 30, 50]" template="PrevPageLink PageLinks NextPageLink" />
            </div>
        </div>

        <!-- Попап деталей -->
        <Dialog class="w-full border-none" modal v-model:visible="popupVisible"
            :position="screenSize == 'xs' ? 'bottom' : 'center'"
            :style="(screenSize == 'xs' || screenSize == 'sm' || screenSize == 'md') ? { width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important' } : { width: 'auto' }"
            :contentStyle="(screenSize == 'xs' || screenSize == 'sm' || screenSize == 'md') ? { height: '100%' } : { height: 'auto' }"
            :class="(screenSize == 'xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">
            <template #header>
                <span class="text-lg font-medium">Подробности</span>
            </template>

            <div v-if="selectedProduct" class="w-full">
                <div class="w-full surface-0 border-round-xl p-3 mb-3">
                    <div class="flex flex-column gap-2">
                        <span class="text-800 font-semibold text-base">{{ getTitle(selectedProduct) }}</span>
                        <div class="flex gap-2 align-items-center">
                            <span v-if="selectedProduct.category"
                                class="text-500 text-xs border-1 surface-border border-round-md px-2 py-1">{{
                                selectedProduct.category }}</span>
                            <span class="text-800 font-medium">{{ formatPrice(selectedProduct) }}</span>
                        </div>
                        <div class="flex flex-column gap-1 text-700 text-sm">
                            <span v-if="getDataAmount(selectedProduct)">{{ t('data') }}: {{
                                getDataAmount(selectedProduct) }}</span>
                            <span v-if="getValidity(selectedProduct)">{{ t('validity') }}: {{
                                getValidity(selectedProduct) }}</span>
                            <span v-if="getProviderName(selectedProduct)">{{ t('provider') }}: {{
                                getProviderName(selectedProduct)
                                }}</span>
                        </div>
                        <div v-if="selectedProduct.countries || selectedProduct.coverage" class="mt-2">
                            <span class="text-700 text-sm mb-2 inline-block">Страны</span>
                            <div class="flex flex-row flex-wrap gap-2">
                                <span v-for="cc in normalizeCountries(selectedProduct)" :key="cc"
                                    class="text-700 text-xs border-1 surface-border border-round-md px-2 py-1">
                                    {{ getCountryTitle(cc) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template #footer>
                <div class="field w-full">
                    <Button @click="Order()" label="Заказать" :loading="loadingOrder"
                        :disabled="loading || loadingOrder || !selectedProduct"
                        class="w-full p-button-primary bg-primary text-white border-none border-round-xl" />
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import countriesJson from '@/assets/json/countries.json'

export default {
    name: 'EsimOrders',
    data() {
        return {
            loading: true,
            products: [],
            total: 0,
            limit: 10,
            skip: 0,
            countriesOptions: [],
            popupVisible: false,
            selectedProduct: null,
            loadingOrder: false,
            orderResult: null,
        }
    },
    methods: {
        t(key) {
            const map = {
                data: 'Трафик',
                validity: 'Срок',
                provider: 'Провайдер',
            }
            return map[key] || key
        },
        async fetchOrders() {
            this.loading = true
            try {
                const api = new Connect()
                const res = await api.GetEsimOrders()
                const items = res && res.result !== false ? (res.items || res.data || res) : []
                this.products = Array.isArray(items) ? items : []
                this.total = res?.total || (Array.isArray(items) ? items.length : null)
                this.collectCountries()
                if(this.products.length === 0) {
                    this.$emit('no_orders')
                }
            } finally {
                this.loading = false
            }
        },
        collectCountries() {
            const setCountries = new Map()
            if (Array.isArray(countriesJson)) {
                countriesJson.forEach(c => {
                    if (c && c.iso) setCountries.set(c.iso, { code: c.iso, title: c.title || c.name || c.iso })
                })
            }
            this.products.forEach(p => {
                const cs = p?.countries || p?.coverage || []
                if (Array.isArray(cs)) {
                    cs.forEach(code => {
                        if (!setCountries.has(code)) setCountries.set(code, { code, title: code })
                    })
                }
            })
            this.countriesOptions = Array.from(setCountries.values()).sort((a, b) => a.title.localeCompare(b.title))
        },
        getTitle(p) { return p?.title || p?.name || '-' },
        getProviderName(p) { return p?.provider?.title || p?.provider?.name || p?.provider_name || '' },
        getDataAmount(p) {
            const val = this.getDataValue(p)
            if (!val) return ''
            return `${val} GB`
        },
        getDataValue(p) {
            const v = p?.data || p?.data_gb || p?.traffic_gb || 0
            return Number(v) || 0
        },
        getValidity(p) {
            const v = p?.validity || p?.days || p?.validity_days
            return v ? `${v} дней` : ''
        },
        getPrice(p) {
            const price = p?.pricing && p.pricing.retail ? p.pricing.retail : 0
            return Number(price) || 0
        },
        formatPrice(p) {
            const price = this.getPrice(p)
            const currency = p?.pricing && p.pricing.currency ? p.pricing.currency : (p?.currency_code || 'USD')
            const helper = new Helper()
            try {
                return helper.format_amount(price, currency, (currency === 'rub' || currency === 'idr') ? 0 : 2)
            } catch (e) {
                return `${price} ${currency}`
            }
        },
        normalizeCountries(p) {
            const cs = p?.countries || p?.coverage || []
            if (Array.isArray(cs)) return cs
            if (cs && Array.isArray(cs.countries)) return cs.countries
            return []
        },
        getCountryTitle(code) {
            const found = this.countriesOptions.find(c => c.code === code)
            return found ? found.title : code
        },
        openPopup(p) {
            this.selectedProduct = p
            this.popupVisible = true
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        async Order() {
            if (!this.selectedProduct || this.loadingOrder) return
            this.loadingOrder = true
            try {
                const api = new Connect()
                const product_id = this.selectedProduct.id
                const product_category = 'data'
                const res = await api.CreateEsimOrder(product_id, product_category)
                if (res.result && res.data) this.orderResult = res
                else {
                    if (res.message) this.showMess('error', 'Ошибка', res.message)
                    else this.showMess('error', 'Ошибка', 'Не удалось создать заказ')
                }
            } finally {
                this.loadingOrder = false
            }
        }
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize }
    },
    watch: {
        skip() {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            this.fetchOrders()
        }
    },
    async beforeCreate() {
        this.helper = new Helper()
    },
    async mounted() {
        await this.fetchOrders()
    }
}
</script>